var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h2',[_c('a',{attrs:{"id":"_0"}}),_vm._v("后端开发")]),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("开发规范")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("微服务相关")])])])])])
}]

export { render, staticRenderFns }